import RightsCategory from "../RightsCategory";
import store from "../../store/configureStore";

class RightsCategoryBuilder {
  static buildRightsCategory(
    descriptionHash,
    id,
    image,
    subtitleHash,
    titleHash
  ) {
    if (
      descriptionHash == null ||
      id == null ||
      subtitleHash == null ||
      titleHash == null
    ) {
      return null;
    }

    if (
      typeof descriptionHash !== "string" ||
      typeof id !== "string" ||
      typeof subtitleHash !== "string" ||
      typeof titleHash !== "string"
    ) {
      return null;
    }

    const translationMap = store.getState().rights.translationMap;
    if (
      !translationMap.hasOwnProperty(descriptionHash) ||
      !translationMap.hasOwnProperty(subtitleHash) ||
      !translationMap.hasOwnProperty(titleHash)
    ) {
      return null;
    }

    const translatedDescription = translationMap[descriptionHash];
    const translatedSubtitle = translationMap[subtitleHash];
    const translatedTitle = translationMap[titleHash];

    return new RightsCategory(
      translatedDescription,
      descriptionHash,
      id,
      image,
      translatedSubtitle,
      subtitleHash,
      translatedTitle,
      titleHash
    );
  }
}

export default RightsCategoryBuilder;
